// Built-in import
import * as React from "react"
// External import
import { IProperty } from "@/types/properties"
import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";



const PeriodMonths = ({value}) => {

  const { t } = useTranslation(["common"]);

  return (
    <Stack
      direction="row"
      justifyContent={"space-between"}
      flexWrap="wrap"
      px={1}
      sx={{
        [`& a`]: {
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: (t) => t.palette.primary.main,
          ":hover": {
            textDecoration: "underline !important",
          },
        },
      }}
    >
      <Typography variant="smallMedium" color="text.primary">
        {t("common:period_months_description")}:
      </Typography>
      <Typography variant="smallMedium" color="grey.400">
        {value}
      </Typography>
    </Stack>
  )
}

export default PeriodMonths
